import type { ReviewStatus } from '@/lib/consoleApi';
import { statusBadgeMeta } from '@/lib/statusBadge';

export function StatusBadge({ status }: { status: ReviewStatus }) {
  const meta = statusBadgeMeta(status);
  return (
    <span data-testid="status-badge" className={`inline-block whitespace-nowrap rounded-pill px-2 py-0.5 text-[11px] font-semibold ${meta.className}`}>
      {meta.label}
    </span>
  );
}
